// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pwFo7NZSsvZ8qLwvDE5n,.jlxv8LVaL_aVO8ThZ3iJ button,.O7727qr43nRbsxc37Kgg{padding:22px}.pwFo7NZSsvZ8qLwvDE5n svg,.jlxv8LVaL_aVO8ThZ3iJ button svg,.O7727qr43nRbsxc37Kgg svg{width:24px !important;height:24px !important}.pwFo7NZSsvZ8qLwvDE5n:hover,.jlxv8LVaL_aVO8ThZ3iJ button:hover,.O7727qr43nRbsxc37Kgg:hover{background-color:var(--app-mainNavigationPanel-iconButton-hoverColor)}.BUshJkeerYlqeCHEOPok{--footer-menu-position: calc(100% - var(--spacing-md))}.Op8WfA2NUe3yxkXazG7h{margin-right:var(--spacing-xxxs);margin-left:var(--spacing-xxxs)}.Qq7LkqRWoWmu2mpuJr62{flex-direction:column}.O7727qr43nRbsxc37Kgg.oaIc77L55NpUG7rDPG4E{background-color:var(--app-navigationPanel-navigationButtonBackgroundActiveColor)}.O7727qr43nRbsxc37Kgg:disabled{opacity:1}.s2ZDmuuJMP_0PK0KG8vr{position:relative}.pwFo7NZSsvZ8qLwvDE5n{--notification-circle-top: var(--spacing-xxxs)}.Zmo03ZUn2X9FDEcjeHVv{top:auto;bottom:100%;transform:translateY(32px);right:auto;left:56px;margin-left:-var(--spacing-xs)}.S_OfUuDgZcTo6ZzHI34A{display:flex;flex-direction:column;align-items:center;padding:var(--spacing-xxs)}.S_OfUuDgZcTo6ZzHI34A>span{display:none}.S_OfUuDgZcTo6ZzHI34A .RWcrRDISYIcrFSHqBX6w{display:none}.S_OfUuDgZcTo6ZzHI34A:hover{background-color:var(--app-mainNavigationPanel-iconButton-hoverColor);transition:var(--transition-default);border-radius:var(--border-radius-sm)}.CY1S5RB4vBmdeiMI4AIG{left:48px;bottom:var(--spacing-md);z-index:20}`, "",{"version":3,"sources":["webpack://./src/components/navigation/navigation-panel/navigation-panel-footer/navigation-panel-footer-new.scss"],"names":[],"mappings":"AAMA,yEACI,YAAA,CAEA,qFACI,qBAAA,CACA,sBAAA,CAEJ,2FACI,qEAAA,CAIR,sBACI,sDAAA,CAGJ,sBACI,gCAAA,CACA,+BAAA,CAGJ,sBACI,qBAAA,CAKA,2CACI,iFAAA,CAGJ,+BACI,SAAA,CAUR,sBACI,iBAAA,CAGJ,sBACI,8CAAA,CAIJ,sBACI,QAAA,CACA,WAAA,CACA,0BAAA,CACA,UAAA,CACA,SAAA,CACA,8BAAA,CAGJ,sBACI,YAAA,CACA,qBAAA,CACA,kBAAA,CACA,0BAAA,CACA,2BACI,YAAA,CAGJ,4CACI,YAAA,CAGJ,4BACI,qEAAA,CACA,oCAAA,CACA,qCAAA,CAIR,sBACI,SAAA,CACA,wBAAA,CACA,UAAA","sourcesContent":["@use \"~styles/theme\" as theme;\n@use \"~styles/colors/base-colors\" as baseColor;\n\n// TODO When removing FLAG_RESTRUCTURED_NAVIGATION/isRestructuredNavPanelActive, rename this file\n// to navigation-panel-footer.scss and delete navigation-panel-footer.scss\n\n%iconButton {\n    padding: 22px;\n\n    svg {\n        width: 24px !important;\n        height: 24px !important;\n    }\n    &:hover {\n        background-color: var(--app-mainNavigationPanel-iconButton-hoverColor);\n    }\n}\n\n.navigationPanelFooter {\n    --footer-menu-position: calc(100% - var(--spacing-md));\n}\n\n.hourglassIcon {\n    margin-right: var(--spacing-xxxs);\n    margin-left: var(--spacing-xxxs);\n}\n\n.hourglassIconTooltipTrigger {\n    flex-direction: column;\n}\n\n.supportLink {\n    @extend %iconButton;\n    &.active {\n        background-color: var(--app-navigationPanel-navigationButtonBackgroundActiveColor);\n    }\n\n    &:disabled {\n        opacity: 1;\n    }\n}\n\n.darkModeButtonContainer {\n    button {\n        @extend %iconButton;\n    }\n}\n\n.notificationButtonContainer {\n    position: relative;\n}\n\n.notificationButton {\n    --notification-circle-top: var(--spacing-xxxs);\n    @extend %iconButton;\n}\n\n.notificationMenu {\n    top: auto;\n    bottom: 100%;\n    transform: translateY(32px);\n    right: auto;\n    left: 56px;\n    margin-left: -var(--spacing-xs);\n}\n\n.userName {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    padding: var(--spacing-xxs);\n    > span {\n        display: none;\n    }\n\n    .kebabIcon {\n        display: none;\n    }\n\n    &:hover {\n        background-color: var(--app-mainNavigationPanel-iconButton-hoverColor);\n        transition: var(--transition-default);\n        border-radius: var(--border-radius-sm);\n    }\n}\n\n.userMenu {\n    left: 48px;\n    bottom: var(--spacing-md);\n    z-index: 20;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"whiteColor": `var(--color-white)`,
	"oemLicenseKeysBulkImportModal": `var(--color-grey-950)`,
	"homeViewTierTypeLabelTextColor": `var(--color-grey-500)`,
	"homeCurrentPlanRedColor": `var(--color-purple-1050)`,
	"homeCurrentPlanBlueColor": `var(--color-blue-1000)`,
	"homeCurrentPlanYellowColor": `var(--color-yellow-1000)`,
	"homeCurrentPlanIconRedColor": `var(--color-purple-800)`,
	"homeCurrentPlanIconBlueColor": `var(--color-sky-700)`,
	"homeCurrentPlanIconYellowColor": `var(--color-orange-300)`,
	"homeCardTextColor": `var(--color-grey-700)`,
	"homeCardVersionColor": `var(--color-grey-700)`,
	"homeCardBackgroundColor": `var(--color-grey-1000)`,
	"homeCardBorderColor": `var(--color-grey-950)`,
	"homeCardNameColor": `var(--color-grey-500)`,
	"homeWireIconColor": `var(--color-purple-700)`,
	"homeWireIconBackgroundColor": `var(--color-purple-300)`,
	"activeBackgroundColor": `var(--color-blue-700)`,
	"primaryButtonBackgroundColor": `var(--color-blue-700)`,
	"secondaryButtonForegroundColor": `var(--color-blue-500)`,
	"bannerBackgroundColor": `rgba(13,27,181,.5)`,
	"linkTextColor": `var(--color-blue-500)`,
	"primaryButtonBackgroundHoverColor": `var(--color-blue-800)`,
	"secondaryButtonBackgroundHoverColor": `var(--color-blue-1000)`,
	"destructiveButtonBackgroundHoverColor": `var(--color-red-900)`,
	"primaryButtonBackgroundActiveColor": `var(--color-blue-900)`,
	"destructiveButtonBackgroundColor": `var(--color-red-950)`,
	"navigationButtonBackgroundActiveColor": `var(--color-blue-1000)`,
	"chartNegativeColor": `var(--color-red-500)`,
	"chartPositiveColor": `var(--color-green-500)`,
	"chartNeutralColor": `var(--color-grey-500)`,
	"errorBackgroundColor": `var(--color-red-600)`,
	"errorBorderColor": `var(--color-red-600)`,
	"errorTextColor": `var(--color-red-600)`,
	"deleteScheduleLinkColor": `#db2828`,
	"errorWrapperBackgroundColor": `var(--color-red-400)`,
	"warningBackgroundColor": `var(--color-orange-800)`,
	"warningTextColor": `var(--color-orange-800)`,
	"secondaryWarningBackgroundColor": `var(--color-yellow-700)`,
	"secondaryWarningBorderColor": `var(--color-yellow-700)`,
	"successBorderColor": `var(--color-green-500)`,
	"successTextColor": `var(--color-green-500)`,
	"pageBackgroundColor": `var(--color-grey-1000)`,
	"wrapperBackgroundColor": `var(--color-blue-200)`,
	"urlSectionBackgroundColor": `var(--color-blue-900)`,
	"wrapperBorderColor": `var(--color-blue-500)`,
	"modelBoxBackgroundColor": `var(--color-grey-900)`,
	"contentBackgroundColor": `var(--color-grey-1000)`,
	"secondaryButtonBackgroundColor": `var(--color-grey-950)`,
	"textColor": `var(--color-white)`,
	"textGreyColor": `var(--color-grey-700)`,
	"primaryButtonForegroundColor": `var(--color-white)`,
	"bannerForegroundColor": `var(--color-grey-900)`,
	"chartOutlineColor": `var(--color-grey-1000)`,
	"modalOverlayColor": `rgba(33,32,32,.4)`,
	"contentDividerColor": `var(--color-grey-1000)`,
	"contentBorderColor": `var(--color-grey-1000)`,
	"nestedContentBorderColor": `var(--color-grey-500)`,
	"disabledButtonBackgroundColor": `var(--color-grey-500)`,
	"disabledButtonForegroundColor": `var(--color-grey-900)`,
	"inputHintColor": `var(--color-grey-500)`,
	"inputBackgroundColor": `var(--color-grey-900)`,
	"hoverBackgroundColor": `var(--color-grey-1000)`,
	"toggleCheckedBackgroundColor": `var(--color-blue-500)`,
	"toggleUncheckedBackgroundColor": `var(--color-grey-500)`,
	"chartFirstSet": `#708add`,
	"chartSecondSet": `#dd75a0`,
	"chartThirdSet": `#4a7ab6`,
	"chartForthSet": `#5f96bc`,
	"chartFifthSet": `#c4874a`,
	"chartSixthSet": `#b63e5c`,
	"chartSeventhSet": `#6c8fa9`,
	"chartEighthSet": `#f3a14e`,
	"chartNinthSet": `#88bbdb`,
	"chartTenthSet": `#e2afc3`,
	"chartEleventhSet": `#b1bfde`,
	"chartTwelfthSet": `#facf96`,
	"optional": `var(--color-white)`,
	"disabledTextColor": `var(--color-grey-900)`,
	"colorPickerBlack": `var(--color-grey-1000)`,
	"iconFillColor": `var(--theme-icon-fill-default)`,
	"sortIconRegularColor": `var(--color-grey-500)`,
	"sortIconHoverColor": `var(--color-blue-500)`,
	"sortIconActiveColor": `var(--color-white)`,
	"diamondTierBannerBorderColor": `var(--color-pink-700)`,
	"starTierBannerBorderColor": `var(--color-purple-900)`,
	"chartSuccessColor": `var(--color-green-600)`,
	"chartFailColor": `var(--color-red-800)`,
	"textFieldColor": `var(--color-grey-1000)`,
	"focusOutlineColorButton": `#d661e5`,
	"tooltipTextColor": `var(--color-grey-900)`,
	"tooltipBackgroundColor": `var(--color-grey-150)`,
	"chipBackgroundColor": `var(--color-grey-900)`,
	"chipContentColor": `var(--color-white)`,
	"chipUserIconColor": `var(--color-grey-1000)`,
	"successIconColor": `var(--color-green-500)`,
	"errorIconColor": `var(--color-red-500)`,
	"localBannerBackgroundColor": `var(--color-blue-1000)`,
	"localBannerBorderColor": `var(--color-grey-950)`,
	"errorBannerBackgroundColor": `var(--color-red-300)`,
	"localBannerTextColor": `var(--color-white)`,
	"successBadgeTextColor": `var(--color-green-200)`,
	"warningBadgeBackgroundColor": `var(--color-yellow-600)`,
	"warningBadgeTextColor": `var(--color-yellow-900)`,
	"errorBadgeBackgroundColor": `var(--color-red-950)`,
	"errorBadgeTextColor": `var(--color-white)`,
	"infoBadgeBackgroundColor": `var(--color-blue-800)`,
	"infoBadgeTextColor": `var(--color-white)`,
	"infoIconBackgroundColor": `var(--color-grey-150)`,
	"neutralBadgeBackgroundColor": `var(--color-grey-800)`,
	"neutralBadgeTextColor": `var(--color-white)`,
	"strokeColor": `var(--color-blue-900)`,
	"textHighlightForegroundColor": `linear-gradient(0deg, rgba(250, 200, 16, 0.3) 0%, rgba(250, 200, 16, 0.3) 100%)`,
	"textHighlightBackgroundColor": `var(--color-white)`,
	"skeletonLoaderBackgroundColor": `var(--color-grey-1000)`,
	"fourthLevelTierBackgroundColor": `var(--color-purple-900)`,
	"defaultStarColor": `var(--color-green-800)`,
	"addOnsCheckmarkColor": `var(--color-green-500)`,
	"warningBannerBackgroundColor": `var(--color-yellow-600)`,
	"warningBannerBorderColor": `var(--color-yellow-150)`,
	"warningBannerTextColor": `var(--color-grey-1000)`,
	"warningIconBackgroundColor": `var(--color-grey-1000)`,
	"warningIconExclamationColor": `var(--color-yellow-700)`,
	"hoverColor": `rgba(var(--color-blue-700), 0.3)`,
	"navigationButtonBackgroundHoverColor": `var(--color-blue-1000)`,
	"conditionToggleButtonBackgroundColor": `var(--color-grey-1000)`,
	"conditionToggleButtonBorderColor": `var(--color-grey-900)`,
	"conditionTableBackgroundColor": `var(--color-grey-1000)`,
	"conditionTableBorderColor": `var(--color-grey-900)`,
	"conditionTableNestedBackgroundColor": `var(--color-grey-1000)`,
	"modularPurpleColor": `var(--color-purple-600)`,
	"modularBackgroundPurpleColor": `var(--color-purple-1000)`,
	"readyToUseSkyBlueColor": `var(--color-sky-600)`,
	"readyToUseBackgroundBlueColor": `var(--color-blue-1000)`,
	"readyToUseBorderBlueColor": `var(--color-sky-900)`,
	"modularBorderPurpleColor": `var(--color-purple-950)`,
	"integrationGreenColor": `var(--color-green-400)`,
	"integrationBorderGreenColor": `var(--color-green-900)`,
	"integrationBackgroundGreenColor": `var(--color-green-950)`,
	"descriptionTextColor": `var(--color-grey-700)`,
	"lightGreenBackgroundColor": `var(--color-green-200)`,
	"lightBlueBackgroundColor": `var(--color-blue-200)`,
	"errorBannerColor": `var(--color-red-300)`,
	"errorBannerTextColor": `var(--color-grey-900)`,
	"bannerIconBackgroundColor": `var(--color-red-800)`,
	"bannerIconColor": `var(--color-white)`,
	"accordianSuccessBackgroundColor": `var(--color-green-950)`,
	"accordianSuccessBorderColor": `var(--color-green-950)`,
	"accordianSuccessTextColor": `var(--color-green-500)`,
	"cardBorderColor": `var(--color-grey-900)`,
	"navigationListDividerColor": `var(--color-grey-900)`,
	"userDefinedErrorColor": `var(--color-orange-950)`,
	"ruleGreenColor": `#096442`,
	"ruleYellowColor": `#987100`,
	"ruleBlueColor": `#0156a6`,
	"ruleRedColor": `#a51313`,
	"rulePurpleColor": `#453498`,
	"ruleOrangeColor": `#ca5600`,
	"rulePinkColor": `#c41796`,
	"ruleCyanColor": `#006e80`,
	"ruleGrayColor": `#646262`,
	"defaultTheme": `defaultTheme`,
	"tenantTheme": `tenantTheme`,
	"defaultDarkTheme": `defaultDarkTheme`,
	"tenantDarkTheme": `tenantDarkTheme`,
	"subTenantTheme": `subTenantTheme`,
	"subTenantDarkTheme": `subTenantDarkTheme`,
	"notificationButton": `pwFo7NZSsvZ8qLwvDE5n`,
	"darkModeButtonContainer": `jlxv8LVaL_aVO8ThZ3iJ`,
	"supportLink": `O7727qr43nRbsxc37Kgg`,
	"navigationPanelFooter": `BUshJkeerYlqeCHEOPok`,
	"hourglassIcon": `Op8WfA2NUe3yxkXazG7h`,
	"hourglassIconTooltipTrigger": `Qq7LkqRWoWmu2mpuJr62`,
	"active": `oaIc77L55NpUG7rDPG4E`,
	"notificationButtonContainer": `s2ZDmuuJMP_0PK0KG8vr`,
	"notificationMenu": `Zmo03ZUn2X9FDEcjeHVv`,
	"userName": `S_OfUuDgZcTo6ZzHI34A`,
	"kebabIcon": `RWcrRDISYIcrFSHqBX6w`,
	"userMenu": `CY1S5RB4vBmdeiMI4AIG`
};
export default ___CSS_LOADER_EXPORT___;
